<h3 color="primary" class="popup-header">Client Details</h3>
<mat-dialog-content class="mat-typography">
  <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
    <mat-card class="generalInfo">
      <mat-card-header>
        <mat-card-title>
          <span class="card-title-text">Client Information</span>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ul class="generalInfo_details">
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="8">Business Name</li>
            <li fxFlex="1"> : </li>
            <li fxFlex="25" primaryColor>{{clientInfo?.businessName}}</li>

            <li fxFlex="8">Contact Person</li>
            <li fxFlex="1"> : </li>
            <li fxFlex="30" primaryColor>{{clientInfo?.contactPerson}}</li>

            <li fxFlex="7">Phone Number</li>
            <li fxFlex="1"> : </li>
            <li fxFlex="18" primaryColor>{{clientInfo?.contactNumber}}</li>
          </div>

          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="8">Email Address</li>
            <li fxFlex="1"> : </li>
            <li fxFlex="25" primaryColor>{{clientInfo?.contactEmail}}</li>

            <li fxFlex="8">Address 1</li>
            <li fxFlex="1"> : </li>
            <li fxFlex="30" primaryColor>{{clientInfo?.address1}}</li>

            <li fxFlex="7">Address 2</li>
            <li fxFlex="1"> : </li>
            <li fxFlex="18" primaryColor>{{clientInfo?.address2}}</li>
          </div>

          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="8">City</li>
            <li fxFlex="1"> : </li>
            <li fxFlex="25" primaryColor>{{clientInfo?.city}}</li>

            <li fxFlex="8">State</li>
            <li fxFlex="1"> : </li>
            <li fxFlex="30" primaryColor>{{clientInfo?.stateName}}</li>
 
            <li fxFlex="7">Zip Code</li>
            <li fxFlex="1"> : </li>
            <li fxFlex="18" primaryColor>{{clientInfo?.zip}}</li>
          </div>

          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="8">Fax Number</li>
            <li fxFlex="1"> : </li>
            <li fxFlex="25" primaryColor>{{clientInfo?.faxNumber}}</li>

            <li fxFlex="8">Sales Rep Name</li>
            <li fxFlex="1"> : </li>
            <li fxFlex="30" primaryColor>{{clientInfo?.salesRepName}}</li>

            <li fxFlex="7">Specialty Type</li>
            <li fxFlex="1"> : </li>
            <li fxFlex="18" primaryColor>{{clientInfo?.clinicalSettingName}}</li>
          </div>

          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="8">Billing Type</li>
            <li fxFlex="1"> : </li>
            <li fxFlex="25" primaryColor>{{clientInfo?.billingTypeName}}</li>

            <li fxFlex="8">EMR Account ID</li>
            <li fxFlex="1"> : </li>
            <li fxFlex="30" primaryColor>{{clientInfo?.accountID}}</li>
          </div>        
        </ul>
      </mat-card-content>
    </mat-card>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="popup-footer">
  <button mat-raised-button color="warn" (click)="cancelClick()">
    <i class="fas fa-times"></i> Close
  </button>
</mat-dialog-actions>